import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const Embedded = () => {
    const faqSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is covered in the Embedded Systems Training Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our Embedded Systems Training Course cover every important topic and tools that will help you get the best job in the market. If you are new to this field, then you must enrol in this course because we provide training from the basics of C Language and Data Structures to advanced learning. This course contains all the important topics, such as device drivers, network protocols, and many more, to provide the best learning opportunities."
      }
    },
    {
      "@type": "Question",
      "name": "what are the Advantages of the VLSI Embedded Systems Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The VLSI Embedded Systems Course is one of the best sections for new engineering graduates or working professionals. It is also the best option for those who want to polish their skills in embedded systems so that they will join a good company. This course will give you deep knowledge about this system and help you get a job in the market."
      }
    },
    {
      "@type": "Question",
      "name": "How does the Embedded Systems Program help with job placement?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our Embedded Systems Program provides 100 percent placement service. We not only teach you the skills needed but also help you with job preparation and connections to top MNCs to start your career."
      }
    },
    {
      "@type": "Question",
      "name": "Can I learn embedded systems online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Definitely! We provide online training for Embedded Systems, giving you the flexibility to learn from any location. Our online courses offer the best standard of education as traditional in-person classes."
      }
    },
    {
      "@type": "Question",
      "name": "What is the time duration of the Embedded Systems online Training Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The Embedded Systems Training Course is a five-month course. Our teacher covers all essential topics thoroughly and provides enough time for practical practice and real-world applications."
      }
    },
    {
      "@type": "Question",
      "name": "Will the course cover real-time operating systems?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Real-Time Operating Systems are also included in our course. You will be taught about the operation of the system and its application in embedded systems for managing tasks within the system."
      }
    }
  ]
};

const courseSchema={
  "@context": "https://schema.org",
  "@type": "Course",
  "@id": "https://takshila-vlsi.com/product/embedded-systems-training/#course",
  "name": "Embedded System Software Training Course",
  "description": "Embedded System Software training covering C programming, data structures, Linux programming, microcontrollers, embedded systems, network protocols, Linux kernel basics, device drivers, operating systems, RTOS basics, debugging techniques and system software development.",
  "url": "https://takshila-vlsi.com/product/embedded-systems-training/",
  "provider": {
    "@type": "Organization",
    "name": "Takshila VLSI",
    "url": "https://takshila-vlsi.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
    },
    "email": "info@takshila-vlsi.com",
    "telephone": "+91-9742972744"
  },
  "coursePrerequisites": "B.E/B.Tech in ECE, EEE, EIE, CSE or IT; MCA/M.Sc in Computers or Electronics; or M.E/M.Tech/M.S in Computer Science, Embedded Systems or Electronics.",
  "timeRequired": "P5M",
  "hasCourseInstance": {
    "@type": "CourseInstance",
    "courseMode": [
      "Online",
      "Offline"
    ],
    "location": [
      {
        "@type": "Place",
        "name": "Bengaluru"
      },
      {
        "@type": "Place",
        "name": "Hyderabad"
      }
    ],
    "courseWorkload": "P5M"
  },
  "instructor": {
    "@type": "Person",
    "name": "Mr. Raja",
    "jobTitle": "Embedded Systems Specialist",
    "url": "https://takshila-vlsi.com/teachers/raja/"
  },
  "about": [
    "Embedded System Software",
    "Embedded Systems",
    "C Programming",
    "C++",
    "Data Structures",
    "Linux Programming",
    "Linux Internals",
    "Linux Device Drivers",
    "Microcontrollers",
    "Network Protocols",
    "Operating Systems",
    "Real-Time Operating Systems",
    "Linux Kernel",
    "Firmware Development",
    "Telecom Software Development",
    "System Software Development"
  ],
  "teaches": [
    "Basics of Unix/Linux",
    "C Programming Basics",
    "Basic Operating System Concepts",
    "Networking Basics",
    "Linux Kernel Basics",
    "Embedded System Basics",
    "Data Structures Basics",
    "Software Development Life Cycle"
  ]
};


  return (
    <div>
          <Helmet>
          <title>Embedded Systems Training Course & Placement | Takshila VLSI</title>
          <meta name="description" content="Enroll in Embedded Systems training to learn microcontrollers, RTOS, and IoT applications through real-time projects and dedicated placement assistance with Takshila VLSI." />
          <link rel="canonical" href="https://www.takshila-vlsi.com/product/embedded-systems-training/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Embedded Systems Training Course & Placement | Takshila VLSI" />
          <meta property="og:description" content="Enroll in Embedded Systems training to learn microcontrollers, RTOS, and IoT applications through real-time projects and dedicated placement assistance with Takshila VLSI." />
          <meta property="og:url" content="https://www.takshila-vlsi.com/product/embedded-systems-training/" />
          <meta property="og:site_name" content="Takshila VLSI" />
          <meta property="article:modified_time" content="2024-08-14T13:00:51+00:00" />
          <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/12/Embedded-Systems_Final.jpg" />
          <meta property="og:image:width" content="1000" />
          <meta property="og:image:height" content="623" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:card" content="summary_large_image" />

          <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
                </script>
                <script type="application/ld+json">
                {JSON.stringify(courseSchema)}
                </script>
        </Helmet>
        <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>Embedded System 
                                  <span className='bg-txt mx-3'>Software</span>
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-5">
                                  <h2 className='ws-section_heading pd-03'><span className='font-thin'>Embedded System Courses & Embedded System Software Training
                                  </span> Courses in Bangalore/ Hyderabad</h2>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>
                                  <p>Embedded System Software training course mainly focused on giving theory cum hands-on practical training in C Language, Data structures, Linux programming, Micro Controllers, Embedded Systems, Network Protocols, Kernel Basics and Device Drivers. Course also focus on giving insights of the Software development life cycle processes, Operating systems, Real Time Operating System basics, Linux commands, debugging techniques and various tools &amp; utilities used in System Software Development.</p>
                                  <p>By end of the course you will learn in depth knowledge with practical exposure of all above mentioned areas which makes you to have opportunities with Top MNCs in various specialized areas like Embedded Software development , Networking/protocol software development ,Linux device driver development, Micro controller based system development, Telecom software development.</p>
                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 p-2 bg-14'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE/EIE/CSE/IT.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>MCA/M.Sc (Computers/Electronics).
                      </div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in Computer Science Streams/Embedded Systems/Electronics Streams.
                      </div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>5 Months</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Whole training is provided by 15+ years Industry experts working in Top MNCs.</div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Gives Expertise in three domains <strong>(Protocol Development, Device Drivers, Micro Controllers).</strong></div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Training is from very basics and topics are taught very clearly.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Focus on clear and deep understanding of Concepts with well-designed material.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Hands on experience with well designed Lab exercises in each area covered in Course.</div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>24×7 Lab Support with Lab practice handouts and course material delivery.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, job-oriented training with 100% placement assistance.
                      </div>
                  </div>
                  
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/raja/'><h4>Mr.Raja</h4></a>
              <h6 className='pb-3'>(Embedded Systems Specialist)</h6>
              <p>Mr.Raja comes with 19+ years of rich Development and Training experience with Top MNCs in Embedded/Networking/Telecom domains from driver level to Application level.</p>
              <p>His sound knowledge and commitment to deliver the knowledge effectively helps even the average students to shape themselves as excellent Embedded System Software Engineers.</p>
              <div class="wpb_wrapper">
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Skills:</strong><br/>
                      C, C++, Data Structures,<br/>
                      Python, Linux Programming,<br/>
                      Linux Internals, Linux drivers,<br/>
                      OS Concepts, RTOS</p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Worked On:</strong><br/>
                      Application Layer Protocols,<br/>
                      Embedded System Software development,<br/>
                      Driver Development, Firmware development,<br/>
                      Telecom Software development</p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Tools:</strong><br/>
                      CVS, GIT, GNATS, Clear case,<br/>
                      Review tool, Coverity, Valgrind,<br/>
                      GDB, GCov, Cscope, Vi, gcc tool chain</p>
                      </div>
                  </div>
                      </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">Embedded Systems Training / Embedded System Software Training
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                  <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              
              <div class="container my-5 bg-5 p-3 dark-bg radius-1">
                <ul class="nav nav-tabs justify-content-around" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="tab-1" data-bs-toggle="tab" data-bs-target="#1" type="button" role="tab" aria-controls="home" aria-selected="true">Basic Level</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-2" data-bs-toggle="tab" data-bs-target="#2" type="button" role="tab" aria-controls="profile" aria-selected="false">Intermediate Level</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-3" data-bs-toggle="tab" data-bs-target="#3" type="button" role="tab" aria-controls="contact" aria-selected="false">Advanced Level</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-4" data-bs-toggle="tab" data-bs-target="#4" type="button" role="tab" aria-controls="contact" aria-selected="false">Specialized Level</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-5" data-bs-toggle="tab" data-bs-target="#5" type="button" role="tab" aria-controls="contact" aria-selected="false">Wrap Up</button>
                    </li>
                </ul>
                </div>
                <div class="bg-13 p-lg-5 p-2">
                <div class="container">
                <div class="tab-content mt-3 bg-13" id="myTabContent">
                    <div class="tab-pane fade show active" id="1" role="tabpanel" aria-labelledby="tab-1">
                    <div className='row'>
                        <div className='col-lg'>
                        <div className='curriculum-accord accordion'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Module 1: Basics of Unix/Linux</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Basic commands</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>System related commands</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Disk & File system related commands</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>User related commands</div>
                                    </div>
                                </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Module 2: C Programming Basics</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Basic language concepts </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Various statements </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Operators/Expressions </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Control statements </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Module 3: Basic Operating System Concepts
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>What is OS, OS Components  </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Segmentation, Scheduling
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Paging, Demand Paging, Page Replacement Algorithms
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Page Fault, Swapping, Virtual Memory
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Module 4: Networking Basics</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Internet Evolution/Protocols/Standards, OSI Model and TCP/IP Model
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Network Devices, Address Types, Network Media/Network Types, Network Topologies (Physical/Logical)
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Interface Types, Transmission Basics, MAC Types/Ethernet, CSMA/CD, WLAN, IPV4 Addresses
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Delivery and Forwarding of IP Packets, Static Routing & Dynamic Routing, Network Related commands
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Module 5: Linux Kernel Basics</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>What is a Kernel, Kernel Components
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Kernel Activities & Services, Kernel Configuration/Compilation/Booting
                                        </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Linux Kernel System Startup, Linux File System overview
                                        </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Linux Kernel Related Commands
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Module 6: Embedded System Basics</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>What is Embedded Systems, Embedded System Components
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Embedded System Applications
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Embedded System Target Boards Examples
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="6">
                                    <Accordion.Header>Module 7: Data Structures Basics</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Introduction to Data Structures
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Types of Data structures and Algorithms
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="7">
                                    <Accordion.Header>Module 8: SDLC
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>SDLC Basics, SDLC Overview
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Waterfall Model, Iterative Model, Spiral Model, V-Model, Agile Model
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                                </div>
                        </div>
                    </div>
                    </div>

                    <div class="tab-pane fade" id="2" role="tabpanel" aria-labelledby="tab-2">
                    <div className='row'>
                        <div className='col-lg'>
                        <div className='curriculum-accord accordion'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Module 1: C Programming</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>C Program Structure, C Program Compilation Phases</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Pre Processor Directives, Pointers, Typedef, Const, Functions</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Storage Classes, Arrays, Strings</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Structures, Enumeration, Dynamic Memory Allocation</div>
                                    </div>
                                </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Module 2: Data Structures</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Linked Lists, Stacks, Stacks, Hashes, Searching </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Module 3: TCP/IP Concepts
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>BOOTP/ARP/RARP, IPV4/ICMP </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Introduction to Transport Layer
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>UDP/TCP, TELNET/SSH, TFTP/FTP, WWW and HTTP
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Module 4: Debugging Concepts</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>What is Debugging
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Debugging Methods, Debugging Tools/Utilities/Resources
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Module 5: Linux Tools & Networking Tools</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Pattern Search Tools, Compression Tools, Image Transfer Tools
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Packet Capturing Tools, Module Related Tools, Network Related Tools
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Module 6: Linux Programming</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Process, System Call, Context Switching
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Process Management, Process Environment, Process Control, Process Relationships
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>File I/O, Files & Directories, Standard I/O
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Filesystems Internals - inodes, dentry, Pseduo Filesystems - proc, sysfs 
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Process, System Call, Context Switching
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Process Management, Process Environment, Process Control, Process Relationships
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>File I/O, Files & Directories, Standard I/O
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Filesystems Internals - inodes, dentry, Pseduo Filesystems - proc, sysfs 
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="6">
                                    <Accordion.Header>Module 7: Introduction to Devices and Drivers</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Device Interfacing, Controlling LEDs from User Space, Knowing how devices interfaced with CPU & with other devices
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Knowing Different Bus Protocols (UART, I2C, SPI)
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Device Files, Types of Drivers 
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Understanding Mini2440 Development Kit, Knowing Mini2440 UART Registers, Memory Mapped and Port mapped IO's
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="7">
                                    <Accordion.Header>Module 8: Mini Project
                                    </Accordion.Header>
                                  </Accordion.Item>
                                </Accordion>
                                </div>
                        </div>
                    </div>
                    </div>

                    <div class="tab-pane fade" id="3" role="tabpanel" aria-labelledby="tab-3">
                    <div className='row'>
                        <div className='col-lg'>
                        <div className='curriculum-accord accordion'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Module 1: Advanced C Programming</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Pointers to Arrays, Function Pointers, Conditional Compilation</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>All Preprocessor Directives, Inline Functions, Structure/Union Sizes</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Bit Fields, More on Strings, More on Compilation, Linking, Loaders</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Bit Manipulations in depth, Dynamic Memory Allocation in depth</div>
                                    </div>
                                </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Module 2: Advanced Data Structures</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Sorting, Trees, Binary Trees, Binary Search Trees</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Heap & Priority Queues, Graphs </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Module 3: Development Tools
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Putty, Telnet, ssh, Vim, Ctags, Cscope, Make, gcc, ld, Pc-lint, gprof, Valgrind  </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>diff, CVS, Bugzilla, gdb, Jtag, ar, nm, objcopy, objdump, size
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Module 4: Advanced Linux Programming</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Synchronization, IPC, Signals, Advanced I/O
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Multi-Threading, Socket Programming, Daemon
                                    </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Module 5: Linux Kernel Internals</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Kernel Module Development
                                    </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>System Call Sequence and Implementation
                                        </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Memory Management, Kernel Synchronization
                                        </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Interrupt Handling and Bottom Halves
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Module 6: Mini Project</Accordion.Header>
                                    
                                </Accordion.Item>

                                </Accordion>
                                </div>
                        </div>
                    </div>
                    </div>

                    <div class="tab-pane fade" id="4" role="tabpanel" aria-labelledby="tab-4">
                    <div className='row'>
                        <div className='col-lg'>
                        <div className='curriculum-accord accordion'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Module 1: Layer 2/ Layer 3 Protocols</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>STP/RSTP, ACLS, NAT/PAT, RIP/OSPF/BGP</div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>DHCP/DNS, IPV6 Basics</div>
                                    </div>
                                </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Module 2: Device Drivers</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Character Driver Basics, Major and Minor Numbers </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Data Structures, File Operations Structure, File Structure </div>
                                    </div>
                                    <div className='icon-left-bx d-flex mb-2'>
                                        <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                        <div className='icn-heading'>Registering Char Driver, Char Driver Example </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Module 3: Micro Controllers & Embedded Targets
                                    </Accordion.Header>
                                    
                                </Accordion.Item>
                                
                                </Accordion>
                                </div>
                        </div>
                    </div>
                    </div>

                    <div class="tab-pane fade" id="5" role="tabpanel" aria-labelledby="tab-5">
                    <div className='row'>
                        <div className='col-lg'>
                        <div className='curriculum-accord accordion'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Module 1: Major Project</Accordion.Header>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Module 2: Written Tests, Lab Tests and Mock Interviews</Accordion.Header>
                                    
                                </Accordion.Item>
                                
                                </Accordion>
                                </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
              </div>
          
              

          </div>
                  </section>

                 


                  <Companysec/>
                  <section className='ws-section pb-5 bg-white'>
                      <div class="container text-center">
                      <div class="row justify-content-around">
                                      <div class="col-lg-6">
                                          <div className='trainer-box'>
                                          
                                              <div className='trainer-img img-radius mb-3'>
                                              <img src={tr1} alt=''/>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 text-left">
                                          <h2 className='mb-4'>Why We Have the Foremost Embedded Systems Training Program
                                          </h2>
                                          <p>We are proud to say that we offer the foremost embedded systems training. The course focuses mainly on offering theory as well as hands-on practical training in data structures, microcontrollers, network protocols, device drivers, C language, Linux programming, embedded systems, as well as kernel basics. Also, the famous course concentrates on providing insights into the life cycle processes of software development, real-time operating systems basics, debugging techniques, operating systems, Linux commands, as well as varying utilities and tools that are used in the development of system software.</p>
                                          <div className='course-accord dark-bg'>
                                      <Accordion defaultActiveKey="0">
                                      <Accordion.Item eventKey="0">
                                          <Accordion.Header>1. We Are Everywhere</Accordion.Header>
                                          <Accordion.Body>
                                          <p>Even though the internet has made it possible to be virtually everywhere around the world offering services at any given time, we are still physically present in many varying locations around. We offer the foremost embedded systems training in Bangalore through our embedded systems training institute in Bangalore. This availability, together with the amazing online courses that we offer, makes it quite convenient and easy for students to study with us from virtually any part of the world and right from the comfort of their living rooms. All that they need is a device and internet connection.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="1">
                                          <Accordion.Header>2. We Feature the Foremost Design Institutes Around
                                          </Accordion.Header>
                                          <Accordion.Body>
                                          <p>We have the most progressive design institutes in some of the most positive locations around the world. Just two examples of our institutes are the Takshila embedded systems training institute in Bangalore and the Takshila embedded systems training institute in Hyderabad. Our institutes are equipped with the most trending training technologies and methodologies, as well as the most qualified trainers that can be gotten anywhere within the industry. Our trainers are the foremost experts in the industry who are always prepared to share their gathered experience and help their students to build the best possible careers they can build in the VLSI industry.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="2">
                                          <Accordion.Header>3. Highlights of the Features of Our Course
                                          </Accordion.Header>
                                          <Accordion.Body>
                                          <p>By the time you complete this course with us, you will have a deep understanding of as well as a truly practical exposure to all of the skills and areas that have been mentioned. This enables you to have great potential and opportunities with the topmost MNCs in a wide range of varying specialized areas such as protocol/network software development, development of microcontroller-based systems, development of Linux device drivers, as well as the development of telecom software. The foremost features of the course include;</p>
                                          <ul>
                                          <li>You are going to be taught by the foremost experts of the entire industry all of who feature more than fifteen years’ experience at least, and are currently working in the industry.</li>
                                          <li>Your training begins right from the basics and every single thing including topics is taught as clearly as possible.</li>
                                          <li>Hands-on experience together with laboratory exercises that are well-designed in every single area that the course covers.</li>
                                          <li>The development of soft skills, together with job-oriented training which comes with our 100% placement support and assistance.</li>
                                          <li>The course offers real expertise in three key domains – device drivers, protocol development, as well as microcontrollers.</li>
                                          <li>The course focuses on a deep yet clear understanding of all embedded systems design concepts with learning materials and methodologies that are well-designed.</li>
                                          <li>24/7 laboratory support together with quality course materials and handouts for effective classroom practice.</li>
                                          </ul>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="3">
                                          <Accordion.Header>4. 100% Placement Opportunities</Accordion.Header>
                                          <Accordion.Body>
                                          <p>After you complete our embedded software training, you are assured of 100% placement support and assistance. We offer this amazing benefit because our major goal is not just to teach, but to also help engineers that graduate from our institute to build the most successful careers they can in the VLSI industry. Our training processes and methodologies enable our students to learn even the most complex of technologies within the shortest period possible, and they transform them into some of the industry’s foremost professionals within no time at all.</p>
                                          <p>These are the foremost reasons for which we claim to have the foremost embedded systems training program you can get anywhere. We arm you with the necessary knowledge for making the most successful yet most amazing career choices in the lucrative VLSI industry.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      
                                      </Accordion>
                                      </div>
                                      </div>
                                  </div>
                      </div>
                  </section>
                  
      <Whysec/>           
      <Offersec/>


      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>

      
      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. 1. What is covered in the Embedded Systems Training Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our <strong>Embedded Systems Training</strong> Course cover every important topic and tools that will help you get the best job in the market. If you are new to this field, then you must enrol in this course because we provide training from the basics of C Language and Data Structures to advanced learning. This course contains all the important topics, such as device drivers, network protocols, and many more, to provide the best learning opportunities.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. what are the Advantages of the VLSI Embedded Systems Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The <strong>VLSI Embedded Systems Course</strong> is one of the best sections for new engineering graduates or working professionals. It is also the best option for those who want to polish their skills in embedded systems so that they will join a good company. This course will give you deep knowledge about this system and help you get a job in the market.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. How does the Embedded Systems Program help with job placement?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our <strong>Embedded Systems Program</strong> provides 100 percent placement service. We not only teach you the skills needed but also help you with job preparation and connections to top MNCs to start your career.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. Can I learn embedded systems online?</Accordion.Header>
                              <Accordion.Body>
                              <p>Definitely! We provide online training for Embedded Systems, giving you the flexibility to learn from any location. Our online courses offer the best standard of education as traditional in-person classes.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. What is the time duration of the Embedded Systems online Training Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The <strong>Embedded Systems Training Course</strong> is a five-month course. Our teacher covers all essential topics thoroughly and provides enough time for practical practice and real-world applications.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. Will the course cover real-time operating systems?</Accordion.Header>
                              <Accordion.Body>
                              <p>Yes, Real-Time Operating Systems are also included in our course. You will be taught about the operation of the system and its application in embedded systems for managing tasks within the system.</p>
                               </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row g-3">
                              <div class="col-lg-7">
                                  <h2>Don't see your questions ? answered here?</h2>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>

      
      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default Embedded